import { render, staticRenderFns } from "./AuthorizationsEditPage.vue?vue&type=template&id=51b5ae8e&scoped=true&"
import script from "./AuthorizationsEditPage.vue?vue&type=script&lang=js&"
export * from "./AuthorizationsEditPage.vue?vue&type=script&lang=js&"
import style0 from "./AuthorizationsEditPage.vue?vue&type=style&index=0&id=51b5ae8e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51b5ae8e",
  null
  
)

export default component.exports